/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/conponents/ProductFormDeatil/ProductDetailMmuRight.tsx
 * @Description:
 */
import ProductDetailMmuHead from './ProductDetailMmuHead';
import ProductDetailMmuBody from './ProductDetailMmuBody';
import { useEffect } from 'react';
import useLocalPayment from 'hooks/useLocalPayment';
import {
  useTradeModeContext,
  useTradeAgreementContext,
  useProductDetailContext,
  useNetPriceTypeContext,
} from 'views/web/product/context';
import useDetailPriceAndAgreement from '../../Detail/useDetailPriceAndAgreement';
import { NetPriceSourceEnum } from '@/libs/enums';
const ProductDetailMmuRight = ({ skuDetail, shopId }) => {
  const { updateLocalPayment, updateLocalTradeAgreement } = useLocalPayment();
  const { setSelectTradeMode, selectTradeMode } = useTradeModeContext();
  const { selectTradeAgreement, setSelectTradeAgreement } = useTradeAgreementContext();
  const { selectNetPriceType, setSelectNetPriceType } = useNetPriceTypeContext();

  const tradeModeChange = (data) => {
    setSelectTradeMode(data);
    if (data?.sysNo) {
      updateLocalPayment(data.sysNo, skuDetail.supplierSysNo);
    }
    getProductDetail(
      {
        chooseAgreement: {
          supplierSysNo: skuDetail.supplierSysNo,
          agreementSysNo: selectTradeAgreement.sysNo,
          accountPeriod: data.accountPeriod,
          billingPeriod: data.billingPeriod,
        },
        netPriceType: selectNetPriceType,
      },
      true,
    );
  };
  const netPriceChange = (type) => {
    setSelectNetPriceType(type);
    const chooseAgreement = {
      supplierSysNo: skuDetail.supplierSysNo,
      agreementSysNo: selectTradeAgreement.sysNo,
      accountPeriod: selectTradeMode.accountPeriod,
      billingPeriod: selectTradeMode.billingPeriod,
    };
    getProductDetail({ chooseAgreement, netPriceType: type }, true);
  };
  const agreementChange = (val) => {
    const activeTradeAgreement = skuDetail.tradeAgreementEntityList?.find((v) => v.sysNo === val);
    setSelectTradeAgreement(activeTradeAgreement || {});
    let chooseAgreement = null;
    let netPriceType = undefined;
    if (activeTradeAgreement) {
      const activeTradeMode = activeTradeAgreement.discountByMethodList?.[0] || {};
      activeTradeAgreement.sysNo &&
        updateLocalTradeAgreement(activeTradeAgreement.sysNo, skuDetail.supplierSysNo);
      setSelectTradeMode(activeTradeMode);
      activeTradeMode.sysNo && updateLocalPayment(activeTradeMode.sysNo, skuDetail.supplierSysNo);
      chooseAgreement = {
        supplierSysNo: skuDetail.supplierSysNo,
        agreementSysNo: activeTradeAgreement.sysNo,
        accountPeriod: activeTradeMode.accountPeriod,
        billingPeriod: activeTradeMode.billingPeriod,
      };
      if (activeTradeAgreement.netPriceTypeList?.length > 1) {
        netPriceType = skuDetail.netPriceType || NetPriceSourceEnum.LANGE;
      }
    }
    setSelectNetPriceType(netPriceType);
    getProductDetail({ chooseAgreement, netPriceType }, true);
  };
  const { getProductDetail } = useProductDetailContext();
  const { differentTypesAgreement, agreeAndUserTypeIsAvailable } =
    useDetailPriceAndAgreement(skuDetail);
  useEffect(() => {
    const { origin } = differentTypesAgreement;
    if (origin.length) {
      // 存储活跃的交易规则到本地
      selectTradeAgreement?.sysNo &&
        updateLocalTradeAgreement(selectTradeAgreement.sysNo, skuDetail.supplierSysNo);

      selectTradeMode?.sysNo && updateLocalPayment(selectTradeMode.sysNo, skuDetail.supplierSysNo);
    }
  }, [
    skuDetail,
    differentTypesAgreement,
    selectTradeAgreement,
    selectTradeMode,
    updateLocalPayment,
    updateLocalTradeAgreement,
  ]);
  return (
    <div className="product-intro-r" style={{ flex: 1 }}>
      <div className="product-detail">
        {/* <!-- 商品描述相关 --> */}
        <ProductDetailMmuHead
          skuDetail={skuDetail}
          shopId={shopId}
          selectTradeAgreement={selectTradeAgreement}
          agreementChange={agreementChange}
          tradeModeChange={tradeModeChange}
          netPriceChange={netPriceChange}
        />
        <ProductDetailMmuBody
          shopId={shopId}
          skuDetail={skuDetail}
          agreeAndUserTypeIsAvailable={agreeAndUserTypeIsAvailable}
        />
      </div>
    </div>
  );
};
export default ProductDetailMmuRight;
